import { DOCUMENT } from '@angular/common';
import type { OnDestroy, OnInit } from '@angular/core';
import { Component, inject, Renderer2 } from '@angular/core';

import { Subject } from 'rxjs';

import { PlatformThemeService } from '@core/user-interface-legacy';

import { AppInitializationService } from './app-initialization.service';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'rtr-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly renderer = inject(Renderer2);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly appInitializationService = inject(AppInitializationService);
  private readonly themeSrvc = inject(PlatformThemeService);
  private ngOnDestroy$ = new Subject<void>();

  constructor() {
    this.renderer.addClass(
      this.document.body,
      `browser-${this.themeSrvc.resolveBrowserClassname()}`,
    );
  }

  public ngOnInit(): void {
    this.appInitializationService.init();
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
